export const CHECKOUT_URL = 'https://www.legadosalud.com/cart/42871928684629:1'

export interface OfferCard {
  id: string
  badge: string
  badgeTone: 'main' | 'bonus' | 'super'
  title: string
  bullets: string[]
  note?: string
  value: string
  tag: string
  image: string
}

export const offerCards: OfferCard[] = [
  {
    id: 'manual',
    badge: 'PRODUCTO PRINCIPAL',
    badgeTone: 'main',
    title: 'Manual de Autosanación Energética (PDF)',
    bullets: [
      'Protocolos exactos para 80 tipos de dolor psicosomático',
      '+100 recetas con cristales y hierbas medicinales',
      'Diccionario de dolencias con mapa emocional completo',
      'Guía paso a paso para principiantes absolutas',
    ],
    value: '$47.00',
    tag: 'INCLUIDO',
    image:
      'https://cdn.magicpatterns.com/uploads/pdBsSCKjCK6bfoEaC6HTvV/PORTADA_-_MANUAL_DE_LA_AUTOSANACION_ENERGETICA.png',
  },
  {
    id: 'planner',
    badge: 'BONO GRATIS #1',
    badgeTone: 'bonus',
    title: 'Planificador de Autocuidado 7x7',
    bullets: [
      'Ritual de mañana y noche en exactamente 7 minutos',
      'Tracker semanal de síntomas para medir tu progreso',
      'Protocolo de crisis para momentos de emergencia',
    ],
    value: '$27.00',
    tag: 'GRATIS',
    image:
      'https://cdn.magicpatterns.com/uploads/8Uw1ZaTzpwZAkWJjGCED1Y/BONO_1_PLANIFICADOR_DE_AUTOCUIDADO_-_PORTADA.png',
  },
  {
    id: 'lunar',
    badge: 'BONO GRATIS #2',
    badgeTone: 'bonus',
    title: 'Calendario Lunar de Sanación',
    bullets: [
      'Rituales específicos para cada fase lunar',
      'Recetas de elixires lunares para potenciar la sanación',
      'Guía de limpieza y carga de cristales mes a mes',
    ],
    value: '$27.00',
    tag: 'GRATIS',
    image:
      'https://cdn.magicpatterns.com/uploads/7RpQPyBWSJbCNcRqWRAm2X/Bono_2_-_CALENDARIO_LUNAR_DE_SANACION_PORTADA.png',
  },
  {
    id: 'numerologia',
    badge: '⚡ SÚPER BONO — SOLO HOY',
    badgeTone: 'super',
    title: 'Numerología Cabalística Personalizada',
    bullets: [
      'Análisis de tu nombre y fecha de nacimiento',
      'Tus cristales y hierbas específicos para TU vibración',
    ],
    note: '⏰ Se elimina cuando expire el contador',
    value: '$147.00',
    tag: 'GRATIS HOY',
    image:
      'https://cdn.magicpatterns.com/uploads/179rBs5hhpyEPSsohno3Zt/Bono_3_-_Numerologia_Cabalistica_PORTADA.png',
  },
]

export const painPoints: string[] = [
  'Migrañas que aparecen con el estrés',
  'Insomnio crónico sin causa médica',
  'Ansiedad que oprime el pecho',
  'Dolor lumbar que nadie explica',
  'Digestión destruida a pesar de comer bien',
  'Fatiga extrema sin diagnóstico',
]

export interface TestimonialShot {
  src: string
  alt: string
}

export const testimonialShots: TestimonialShot[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/m56sR56DeetuceHDhVDXAE/testimonio_1.png',
    alt: 'Captura de WhatsApp: compró el manual por dolor de estómago crónico y la parte de numerología acertó con sus órganos más vulnerables; ya se siente mucho más ligera.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8x4UkemR848A1cqQAaQyhL/testimonio_2.png',
    alt: 'Captura de WhatsApp: no creía en estas cosas, probó el código del nombre y explica sus patrones emocionales y dolores de cabeza; vale mucho más de lo que pagó.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hMELxkaarqpd9K3T9FWt2N/testimonio_3.png',
    alt: 'Captura de WhatsApp: aplicando la numerología, su nombre reveló el problema lumbar que ningún médico le sabía explicar.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6SP6oMgt8T9M5szRVwfTSc/testimonio_4.png',
    alt: 'Captura de WhatsApp: tras una semana con el protocolo de 7 minutos despertó sin el peso en el cuello y hasta su humor cambió.',
  },
]

export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: '¿Funciona si nunca usé cristales ni hierbas?',
    answer:
      'Sí. Está diseñado para principiantes. Funciona como un libro de cocina: buscas tu síntoma, sigues la receta y la aplicas.',
  },
  {
    question: '¿Tengo que gastar mucho en materiales?',
    answer:
      'No. Las hierbas principales las encuentras en cualquier supermercado por menos de $5. Los cristales básicos son igualmente económicos.',
  },
  {
    question: '¿Reemplaza a mi médico?',
    answer:
      'No. Es medicina integrativa complementaria. Puede coexistir con cualquier tratamiento convencional.',
  },
  {
    question: '¿Cómo recibo el Bono de Numerología?',
    answer:
      'Tras la compra recibirás todo el pack completo directo a tu correo electrónico.',
  },
  {
    question: '¿Qué pasa si no funciona para mí?',
    answer:
      'Tienes 7 días de garantía total. Si no sientes ningún cambio, te devolvemos el 100% sin preguntas.',
  },
]
